import { NextSeo } from 'next-seo';
import PageBanner from '../../components/pageBanner';
import React from 'react';
import Alchemis_lab_item from '@apps/components/blog/alchemis_lab_item';
import { alchemis_lab_data } from '@apps/data/alchemis_lab_data';
import CallToActions from '@apps/components/ico-landing/CallToActions';

const AlchemisLab = () => {
  const metaTitle = "Alchemis Lab - Alchemis";
  const metaDesc = `Be part of our young and innovative team, and we build trust, embrace feedback, grow rapidly, and love our work.`;
  const metaImg = `/images/meta/services-main.png`;
  return (
    <div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <PageBanner text="Alchemis Lab" description="Be part of our young and innovative team, and we build trust, embrace feedback, grow rapidly, and love our work." image={'/images/gradient_dark.jpeg'} />
      <section className="container py-[100px]">
        <Alchemis_lab_item data={alchemis_lab_data}/>
      </section>
      <CallToActions
        title={"Interested in creating a Web3 project?"}
        background={"/images/cta.png"}
        description={"Contact us today to see how our Web3 solution will help you realise your full business potential!"}
        btnText={"Start Now"}
        link={"/contact"}
      />
    </div>
  );
}

export default AlchemisLab;
